module.exports = __webpack_public_path__ + "img/wtb9.acb9512d.png";